import {
  EDL_ITEM_MATERIAUX_TEMPLATE_INITIAL_VALUE,
  edlItemMateriauxTemplateValidationSchema,
} from "../../models/edl";
import { FieldArray, Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import ButtonCard from "../UI/ButtonCard";
import { Croix, PlusBank } from "../UI/Icons";
import Button from "../UI/Button";
import { toInitialValuesFromSchema } from "../../models/utils";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { ModalDialogBody, ModalDialogFooter } from "../UI/ModalDialog";

function EdlMateriauxTemplateForm({
  materiauxTemplateToEdit,
  onDelete,
  onSubmit,
}) {
  const initialValues = toInitialValuesFromSchema(
    edlItemMateriauxTemplateValidationSchema,
    materiauxTemplateToEdit,
    EDL_ITEM_MATERIAUX_TEMPLATE_INITIAL_VALUE,
  );

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={onSubmit}
    >
      {(formikProps) => {
        return (
          <Form>
            <ModalDialogBody>
              <TextInput
                type={"text"}
                name={"nom"}
                label={"Nom de l'élément"}
              />
              <FieldArray
                name="materiaux"
                render={(arrayHelpers) => (
                  <>
                    {formikProps.values?.materiaux.map((child, index) => (
                      <div className={"flex align-items-center"} key={index}>
                        <TextInput
                          name={`materiaux[${index}]`}
                          type={"text"}
                          label={"materiaux"}
                          className={"marginL10 marginR10"}
                        />
                        <span onClick={() => arrayHelpers.remove(index)}>
                          <Croix />
                        </span>
                      </div>
                    ))}
                    <ButtonCard
                      type={"button"}
                      className={`flex justify-content-center align-items-center paddingB10 paddingT10 marginB10 w-100`}
                      onClick={() => {
                        arrayHelpers.push("");
                      }}
                    >
                      <PlusBank />
                      <p className={"secondaryText marginL10"}>
                        Ajouter un matériaux
                      </p>
                    </ButtonCard>
                  </>
                )}
              />
              <FieldArray
                name="degradations"
                render={(arrayHelpers) => (
                  <>
                    {formikProps.values?.degradations.map((child, index) => (
                      <div className={"flex align-items-center"} key={index}>
                        <TextInput
                          name={`degradations[${index}]`}
                          type={"text"}
                          label={"Dégradation"}
                          className={"marginL10 marginR10"}
                        />
                        <span onClick={() => arrayHelpers.remove(index)}>
                          <Croix />
                        </span>
                      </div>
                    ))}
                    <ButtonCard
                      type={"button"}
                      className={`flex justify-content-center align-items-center paddingB10 paddingT10 marginB10 w-100`}
                      onClick={() => {
                        arrayHelpers.push("");
                      }}
                    >
                      <PlusBank />
                      <p className={"secondaryText marginL10"}>
                        Ajouter une dégradation
                      </p>
                    </ButtonCard>
                  </>
                )}
              />
            </ModalDialogBody>
            <ModalDialogFooter>
              <Button
                type="button"
                variant="secondary"
                disabled={formikProps.isSubmitting || !materiauxTemplateToEdit}
                onClick={() => onDelete(materiauxTemplateToEdit.id)}
              >
                Supprimer
              </Button>
              <FormikSubmitButton>Ajouter</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        );
      }}
    </Formik>
  );
}

export default EdlMateriauxTemplateForm;
